<template>
  <div class="nav_box bg">
    <div class="doubleBtn">
      <!-- <p class="inquire btn" @click="checkCondition">查询奖励</p> -->
      <p class="subscribe" @click="joinIn" v-if="joinGroup">
        <img src="@/assets/images/immediately_yy.png" alt="立即预约" />
      </p>
      <!-- :class="{ close: menuShow }" -->
      <i class="menu" @click="menuShow = !menuShow" alt="菜单"></i>
      <!-- <div
        class="hamburger hd bg"
        :class="{ onSelect: active }"
        id="hamburger-1"
        @click="active = !active"
      >
        <span class="line"></span>
        <span class="line"></span>
        <span class="line"></span>
      </div> -->
    </div>
    <transition name="menu-show">
      <div class="popup" v-if="menuShow">
        <div class="mask" @click="menuShow = false"></div>
        <div class="menu-group">
          <div class="menu-list">
            <div
              class="menu-list-item"
              v-for="(item, index) in list"
              :key="'nav' + index"
            >
              <!-- <p class="imgbox">
                <img
                  class="itemchiose"
                  src="@/assets/images/bookchiose.png"
                  alt=""
                  v-if="index == slideIndex"
                />
              </p> -->
              <span
                class="itemname"
                :class="{ active: index === slideIndex }"
                @click="slideTo(index)"
                >{{ item.name }}</span
              >
            </div>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
// import { codes } from "@/js/api";
import Alert from "@/components/alert.vue";
export default {
  name: "headerPage",
  data() {
    return {
      active: false,
      menuShow: false,
      slideIndex: 0,
      list: [
        {
          id: 1,
          name: "回到首頁",
        },
        {
          id: 2,
          name: "預約領豪禮",
        },
        {
          id: 3,
          name: "神劍認主",
        },
        {
          id: 4,
          name: "仙友集結號",
        },
        {
          id: 5,
          name: "里程碑獎勵",
        },
        {
          id: 6,
          name: "職業介紹",
        },
        {
          id: 7,
          name: "遊戲特色",
        },
        {
          id: 8,
          name: "獎勵記錄",
        },
      ],
      prizeList: false,
      joinGroup: false,
    };
  },
  components: {
    Alert,
  },
  mounted() {
    window.addEventListener("scroll", this.handleScroll);
    this.$bus.$on("scrolltop", () => {
      this.slideIndex = 0;
    });
  },
  methods: {
    handleScroll() {
      let scrollTop = document.documentElement.scrollTop
      let offsetTop = document.getElementsByClassName("part2")[0].offsetTop;
      // console.log(scrollTop,offsetTop);
      if (scrollTop + 100 >= offsetTop) {
        this.joinGroup = true;
      } else {
        this.joinGroup = false;
      }
    },
    joinIn() {
      location.href = "https://www.facebook.com/groups/xm.dxz";
    },
    slideTo(page) {
      this.slideIndex = page;
      this.anchor(page);
      this.menuShow = false;
    },
    anchor(page) {
      console.log(page);
      switch (page) {
        case 0:
          this.$bus.$emit("point0", page);
          break;
        case 1:
          this.$bus.$emit("point1", page);
          break;
        case 2:
          this.$bus.$emit("point2", page);
          break;
        case 3:
          this.$bus.$emit("point3", page);
          break;
        case 4:
          this.$bus.$emit("point4", page);
          break;
        case 5:
          this.$bus.$emit("point5", page);
          break;
        case 6:
          this.$bus.$emit("point6", page);
          break;
        case 7:
          // this.$bus.$emit("tips", "活動已結束，請到商店下載體驗");
          this.$bus.$emit("prizeOpen");
          break;
        default:
          //这里是没有找到对应的值处理
          break;
      }
    },
    // checkCondition() {
    //   let phoneData = this.$util.getToken();
    //   if (phoneData) {
    //     let data = this.$util.getToken().token;
    //     codes(data).then((res) => {
    //       console.log(res);
    //       this.$bus.$emit("tips", "奖励记录");
    //     });
    //   } else {
    //     this.$bus.$emit("tips", "請先預約");
    //     return;
    //   }
    // },
  },
};
</script>

<style lang="less" scoped>
.bg {
  background-repeat: no-repeat;
  background-position: 0 0;
  background-size: contain;
}
.nav_box {
  width: 100%;
  max-width: 7.5rem;
  height: 1.5rem;
  background: url("@/assets/images/navigation_bar.png") no-repeat;
  background-size: 100% auto;
  position: fixed;
  top: 0;
  left: 50%;
  z-index: 97;
  transition: all 0.3s;
  transform: translateX(-50%);
  .doubleBtn {
    position: absolute;
    height: 1.1rem;
    top: -0.05rem;
    right: 0;
    display: flex;
    align-items: center;
    cursor: pointer;
    z-index: 1;
    .subscribe {
      height: 1.1rem;
      position: relative;
      top: 0.05rem;
      left: -0.1rem;
      img {
        height: 100%;
        // width: 100%;
      }
    }
    .menu {
      width: 0.9rem;
      height: 0.9rem;
      background-image: url("@/assets/images/menu.png");
      background-size: cover;
    }
    // .close {
    //   background-image: url("@/assets/images/menu-close.png");
    //   width: 1.15rem;
    //   height: 1.15rem;
    //   background-size: 70%;
    //   background-position: center;
    //   background-repeat: no-repeat;
    // }
  }
  .popup {
    position: absolute;
    width: 100%;
    height: 100vh;
    top: 0;
    left: 0;
    pointer-events: auto;
    .mask {
      width: 100%;
      height: 100%;
    }
    .menu-group {
      position: absolute;
      top: 0rem;
      right: 0rem;
      width: 50%;
      height: 100%;
      z-index: 1;
      .menu-list {
        display: flex;
        justify-content: center;
        height: 100%;
        flex-direction: column;
        // padding-left: 25%;
        align-items: center;
        background: url("@/assets/images/booklistbg.png");
        .menu-list-item {
          font-size: 0.3rem;
          color: #fff;
          display: flex;
          align-items: center;
          height: 0.52rem;
          line-height: 0.52rem;
          margin-bottom: 0.3rem;
          cursor: pointer;
          background-size: 200% 12.88rem;
          background-position-x: -2.22rem;
          .imgbox {
            width: 0.5rem;
            height: 0.5rem;
            margin-right: 0.2rem;
            .itemchiose {
              width: 100%;
              height: 100%;
            }
          }
          .itemname {
            display: inline-block;
            &.active {
              color: #4bd3ff;
              &::after {
                content: "";
                height: 0.02rem;
                background: #4bd3ff;
                width: 100%;
                display: block;
              }
            }
            &:hover {
              color: #4bd3ff;
            }
          }
        }
      }
    }
  }
  .menu-show-enter,
  .menu-show-leave-to {
    // opacity: 0;
    transform: translateX(50%);
  }
  .menu-show-enter-to,
  .menu-show-leave {
    // opacity: 1;
    transform: translateX(0%);
  }
  .menu-show-enter-active,
  .menu-show-leave-active {
    transition: all 0.6s ease-in-out;
  }
  // .hamburger {
  //   // position: fixed;
  //   // top: 0.2rem;
  //   // right: 0.3rem;
  //   z-index: 99;
  //   width: 0.7rem;
  //   height: 0.7rem;
  //   display: flex;
  //   flex-direction: column;
  //   justify-content: center;
  //   align-items: center;
  //   .line {
  //     width: 0.38rem;
  //     height: 0.06rem;
  //     background-color: #fff;
  //     display: block;
  //     margin: 0.04rem auto;
  //     transition: all 0.3s ease-in-out;
  //   }
  // }
  // #hamburger-1.onSelect .line:nth-child(1) {
  //   transform: translateY(0.15rem) rotate(45deg);
  // }
  // #hamburger-1.onSelect .line:nth-child(2) {
  //   opacity: 0;
  // }
  // #hamburger-1.onSelect .line:nth-child(3) {
  //   transform: translateY(-0.13rem) rotate(-45deg);
  // }
}
</style>